export default {
      id: "location-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#location",
      toString: function () {
        return this.url;
      }
    }